<template>
  <div class="display-box" >
    <div class="module-layout">
      <!-- <el-select v-model="span" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
        <el-option value="1">1</el-option>
        <el-option value="2">2</el-option>
        <el-option value="3">3</el-option>
      </el-select>
      <div>行</div> -->
      <el-select v-model="col" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
        <el-option :value="1">1</el-option>
        <el-option :value="2">2</el-option>
        <el-option :value="3">3</el-option>
        <el-option :value="4">4</el-option>
        <el-option :value="5">5</el-option>
        <el-option :value="6">6</el-option>
      </el-select>
      <div>列</div>
      <div style="marginLeft:20px">排版</div>
    </div>
    <div class="link-box">
      <p class="w100 font-28 tx-c mb20">信息导航</p>
      <div>
        <draggable
          :group="{ name: 'module', put: true }"
          @add="addModuleItem"
          @update="sortModuleItem"
          :value="subjectData.data"
          animation="300"
          class="link-draggable"
          :ghostClass="`link-items-ghost-${col}`"
        >
          <div class="mb20 pl10 pr10" :style="`width: ${handleWidth(col || 5)};`" v-for="(e, i) in subjectData.data" :key="e.navId" >
            <div class="w100 font-16 tx-c item-box ellipsis" >{{e.navName}}
              <i class="el-icon-error" @click="removeModules(e, i)"></i>
            </div>
          </div> 
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "tinfoLink",
  components: { draggable },
  props: ['childModules'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      subjectData: {},
      span: 1,
      col: 5,
      changed: false,
    };
  },
  created(){
    let subject = this.moduleList.find((item) => {
      return item.cardType === 'LINK'
    })
    if(subject){
      this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
      this.col = subject.cardModules[0].col;
    }
  },
  computed: {
    ...mapGetters(['moduleList']),
  },
  methods: {
    changeLayout(){
      // if(this.col * this.span < this.subjectData.data.length){
      //   this.subjectData.data.length = this.col * this.span
      // }
      this.$emit('caseChanged', true)
    },
    handleWidth(col){
      switch (col) {
        case 1:
          return '100%'
        case 2:
          return '50%'
        case 3:
          return '33.3%'
        case 4:
          return '25%'
        case 5:
          return '20%'
        case 6:
          return '16.6%'
        default:
          return '50%'
      }
    },
    addModuleItem(e){
      // // 判断是否超出个数限制
      // const limit = this.span * this.col;
      // if(this.subjectData.data.length >= limit){
      //   this.$message.warning('超出设置的行数,若要继续添加请修改行列数')
      //   return
      // }
      let targetIndex = e.newIndex;
      let childModulesIndex = e.oldIndex;
      let childModule = this.childModules[childModulesIndex];
      // 判断添加的模块是否存在
      let exist;
      if(this.subjectData.data){
        exist = this.subjectData.data.some((item) => {
          return item.navId === childModule.navId;
        })
      }else {
        this.subjectData.data = []
        exist = false
      }
      if(exist){
        this.$message.warning('不能重复添加已添加的模块')
        return
      }
      this.subjectData.data.splice(targetIndex, 0, childModule);
      this.$emit('caseChanged', true)
    },
    sortModuleItem(e){
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;

      let moduleItem = this.subjectData.data[oldIndex];
      this.subjectData.data.splice(oldIndex, 1);
      this.subjectData.data.splice(newIndex, 0, moduleItem);
      this.$emit('caseChanged', true)
    },
    removeModules(item, index){
      this.subjectData.data.splice(index, 1)
      this.$emit('caseChanged', true)
    },
    isEmpty(){
      return this.subjectData.data.length ? false : true
    },
  },
  watch: {
    'subjectData.data'(val){
      this.$emit('selectedChange', {data:val, module: 'tinfoLink', col: this.col})
    },
    col(val){
      this.$emit('selectedChange', {data:this.subjectData.data, module: 'tinfoLink', col: this.col})
    }
  },
  filters: {}
}
</script>

<style lang="less">
.link-box {
  min-height: 150px;
  background-color: #fff;
  padding: 10px 20px;
  .item-box {
    height: 58px;
    line-height: 58px;
    border-radius: 4px;
    background: rgba(238, 244, 249, 1);
    cursor: move;
    position: relative;
  }
  .item-box:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    .el-icon-error {
      display: block !important;
    }
  }
  .link-draggable {
    min-height: 70px;
    display: flex;
    flex-wrap: wrap;
  }
  .link-items-ghost-1 {
    width: 100%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
  .link-items-ghost-2 {
    width: 50%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
  .link-items-ghost-3 {
    width: 33.3%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
  .link-items-ghost-4 {
    width: 25%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
  .link-items-ghost-5 {
    width: 20%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
  .link-items-ghost-6 {
    width: 16.6%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
  .link-items-ghost-7 {
    width: 14.2%;
    height: 58px;
    padding: 0 10px;
    /deep/ .link-item {
      border: 1px dashed #ccc;
      width: 100%;
      height: 58px;
      margin: 0;
      font-size: 20px;
      line-height: 58px;
    }
  }
}
</style>